import DynamicIcon from './DynamicIcon';

export default DynamicIcon;
